export const initialDays: Day[] = [
    { day_id: 0, day: 'initial', lezen: 'initial', spellen: 'initial' },
    { day_id: 1, day: 'initial', lezen: 'initial', spellen: 'initial' },
    { day_id: 2, day: 'initial', lezen: 'initial', spellen: 'initial' },
    { day_id: 3, day: 'initial', lezen: 'initial', spellen: 'initial' },
    { day_id: 4, day: 'initial', lezen: 'initial', spellen: 'initial' },
    { day_id: 5, day: 'initial', lezen: 'initial', spellen: 'initial' },
    { day_id: 6, day: 'initial', lezen: 'initial', spellen: 'initial' },
];

const today = new Date();
const weekLater = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() + 7
);

export const getInitialData = (
    key: string,
    initialWeekGoal: number
): LogBookEntry => ({
    key,
    layout: 'logbook_entry',
    attributes: {
        firstDayOfWeek: today.getTime(),
        lastDayOfWeek: weekLater.getTime(),
        days: initialDays,
        initialWeekGoal,
        fields: [
            { id: 1, category_id: 1, subTitle: 'Deze week', text: '' },
            { id: 2, category_id: 1, subTitle: 'Doel', text: '' },
            {
                id: 3,
                category_id: 1,
                subTitle: 'Succescriterium',
                text: '',
            },
            { id: 4, category_id: 2, subTitle: 'Deze week', text: '' },
            { id: 5, category_id: 2, subTitle: 'Doel', text: '' },
            {
                id: 6,
                category_id: 2,
                subTitle: 'Succescriterium',
                text: '',
            },
            { id: 7, category_id: 3, subTitle: '', text: '' },
        ],
    },
});
